import { ENTRY_CHANNEL } from './channel'
function skinning() {
  const isSupported = window.CSS && window.CSS.supports
  // 根据访问入口设置不同主题色
  ENTRANCE = +BROSWER_TYPE === 16 ? '建行' : ENTRANCE
  let channel = sessionStorage.getItem('channel') || ''
  ENTRANCE = ENTRY_CHANNEL[channel] || ENTRANCE

  if (isSupported) {
    switch (ENTRANCE) {
      case '建行':
        document.getElementsByTagName('body')[0].classList.add('theme-ccb')
        document.body.style.setProperty('--color-theme', '#09B6F2')
        document.body.style.setProperty('--color-theme2', '#09B6F2')
        document.body.style.setProperty('--color-tagbg', '#e8efff')
        break
      case '深大':
        document.getElementsByTagName('body')[0].classList.add('theme-shenda')
        document.body.style.setProperty('--color-theme', '#09b6f2')
        document.body.style.setProperty('--color-theme2', '#09b6f2')
        document.body.style.setProperty(
          '--color-tagbg',
          'rgba(128, 200, 235, .2)'
        )
        break
      case '中广核、华大':
        document
          .getElementsByTagName('body')[0]
          .classList.add('theme-baojiankang', 'theme-huada')
        document.body.style.setProperty('--color-theme', '#FF4351')
        document.body.style.setProperty('--color-theme2', '#FF4351')
        document.body.style.setProperty('--color-tagbg', '#fef0f1')
        break
      case '南航':
        document
          .getElementsByTagName('body')[0]
          .classList.add('theme-baojiankang', 'theme-nanhang')
        document.body.style.setProperty('--color-theme', '#FF4351')
        document.body.style.setProperty('--color-theme2', '#FF4351')
        document.body.style.setProperty('--color-tagbg', '#fef0f1')
        break
      case '中信':
        document.getElementsByTagName('body')[0].classList.add('theme-zhongxin')
        document.body.style.setProperty('--color-theme', '#C2512F')
        document.body.style.setProperty('--color-theme2', '#C2512F')
        document.body.style.setProperty('--color-bg-r', '#E73439')
        document.body.style.setProperty('--color-bg-tag', '#FBF1EF')
        document.body.style.setProperty('--color-price', '#E83439')
        document.body.style.setProperty(
          '--color-tagbg',
          '#FBF1EF'
        )
        break
      default:
        document.getElementsByTagName('body')[0].classList.add('theme-daishu')
        break
    }
  }
}
export default skinning
